import React from "react";
import { HexColorPicker } from "react-colorful";
import convert from "color-convert";
import { Box, Typography, Grid, TextField, Paper } from "@mui/material";

// Ahora recibe color y setColor por props
export default function PaletaColores({ color, setColor }) {
  const rgb = convert.hex.rgb(color);
  const cmyk = convert.hex.cmyk(color);
  const hsv = convert.hex.hsv(color);
  const hsl = convert.hex.hsl(color);

  const formatValues = {
    RGB: rgb.join(", "),
    CMYK: `${cmyk[0]}%, ${cmyk[1]}%, ${cmyk[2]}%, ${cmyk[3]}%`,
    HSV: `${hsv[0]}°, ${hsv[1]}%, ${hsv[2]}%`,
    HSL: `${hsl[0]}°, ${hsl[1]}%, ${hsl[2]}%`,
  };

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="space-between"
    >
      {/* Columna del picker */}
      <Box sx={{ width: { xs: 130, md: 590 } }}>
        <HexColorPicker color={color} onChange={setColor} style={{ width: "100%" }} />
        <Box mt={2}>
          <Typography variant="caption" fontWeight="bold">
            HEX
          </Typography>
          <TextField
            value={color}
            onChange={(e) => setColor(e.target.value)}
            size="small"
            variant="outlined"
            fullWidth
          />
        </Box>
      </Box>

      {/* Columna de valores */}
      <Grid container spacing={1} direction="column" sx={{ width: { xs: 177, md: "200px" } }}>
        {Object.entries(formatValues).map(([label, value]) => (
          <Grid item key={label}>
            <Paper variant="outlined" sx={{ p: 1 }}>
              <Typography variant="body2" fontWeight="bold">{label}</Typography>
              <Typography variant="body2">{value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
